import type { DescriptionsProps } from 'antd'

// antd berilmagan o'lchamlarni 3 ustun bilan to'ldiradi, shuning uchun hammasi yoziladi.
export const TWO_COLUMNS: DescriptionsProps['column'] = { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }
